import { gql } from '@apollo/client';

export const userAccountFragments = {
  userAccount: gql`
    fragment UserAccountItem on UserAccount {
      defaultProjectId
      email
      id
      isActive
      loginName
      nameFirst
      nameLast
      nameMiddle
      upn
      updatedBy
      updatedTime
      updatedByUser {
        id
        nameFirst
        nameMiddle
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  `,
};

export const SEARCH_USER_ACCOUNTS = gql`
  ${userAccountFragments.userAccount}
  query SearchUserAccounts($searchInput: SearchInput) {
    searchUserAccounts(searchInput: $searchInput) {
      items {
        ...UserAccountItem
        userAccountProjects {
          id
          projectId
        }
        roles {
          id
          description
        }
        restrictions {
          id
          name
        }
        userAccountPhoto {
          id
          photo
        }
      }
    }
  }
`;

export const GET_USER_ACCOUNT_BY_ID = gql`
  ${userAccountFragments.userAccount}
  query UserAccount($id: ID!) {
    userAccount(id: $id) {
      ...UserAccountItem
      roles {
        id
        description
      }
      restrictions {
        id
        name
      }
      userAccountProjects {
        id
        projectId
      }
      userAccountPhoto {
        id
        photo
      }
    }
  }
`;

export const SEARCH_ROLES = gql`
  query SearchRoles($searchInput: SearchInput) {
    searchRoles(searchInput: $searchInput) {
      items {
        description
        id
        roleName
        updatedBy
        updatedTime
      }
    }
  }
`;

export const SEARCH_USER_RESTRICTIONS = gql`
  query SearchRestrictions($searchInput: SearchInput) {
    searchRestrictions(searchInput: $searchInput) {
      items {
        id
        name
        tableName
        whereClause
        updatedTime
        updatedBy
      }
    }
  }
`;

export const SAVE_USER_RESTRICTIONS = gql`
  mutation SaveRestriction($saveRestrictionInput: SaveRestrictionInput!) {
    saveRestriction(saveRestrictionInput: $saveRestrictionInput) {
      restrictions {
        id
        projectId
        name
        tableName
        whereClause
        updatedTime
        updatedBy
      }
      deletedIds
      errors {
        tag: name
        messageKeys
      }
    }
  }
`;

export const CREATE_USER_ACCOUNT = gql`
  ${userAccountFragments.userAccount}
  mutation CreateUserAccount($createUserAccountInput: CreateUserAccountInput!) {
    createUserAccount(createUserAccountInput: $createUserAccountInput) {
      error
      userAccount {
        ...UserAccountItem
        roles {
          id
          description
        }
        restrictions {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_USER_ACCOUNT = gql`
  ${userAccountFragments.userAccount}
  mutation UpdateUserAccount($updateUserAccountInput: UpdateUserAccountInput!) {
    updateUserAccount(updateUserAccountInput: $updateUserAccountInput) {
      error
      userAccount {
        ...UserAccountItem
        restrictions {
          id
          name
        }
        roles {
          id
          description
        }
      }
    }
  }
`;

export const DELETE_USER_ACCOUNT_PROJECT = gql`
  mutation DeleteUserAccountProject($deleteUserAccountProjectInput: DeleteUserAccountProjectInput!) {
    deleteUserAccountProject(deleteUserAccountProjectInput: $deleteUserAccountProjectInput) {
      errors
      id
    }
  }
`;

export const SAVE_ROLES = gql`
  mutation SaveRole($saveRoleInput: SaveRoleInput!) {
    saveRole(saveRoleInput: $saveRoleInput) {
      roles {
        id
        roleName
        description
        projectId
        updatedBy
        updatedTime
      }
      errors {
        tag
        messageKeys
      }
      deletedIds
    }
  }
`;

export const ROLE_PERMISSIONS_BY_ROLE_ID = gql`
  query RolePermissionsByRoleId($roleId: ID!) {
    rolePermissionsByRoleId(roleId: $roleId) {
      id
      roleId
      permission {
        id
        permissionName
      }
    }
  }
`;

export const SEARCH_PERMISSIONS = gql`
  query SearchPermissions($searchInput: SearchInput) {
    searchPermissions(searchInput: $searchInput) {
      items {
        id
        permissionName
      }
    }
  }
`;

export const SAVE_ROLE_PERMISSIONS = gql`
  mutation SaveRolePermissions($saveRolePermissionInput: SaveRolePermissionInput!) {
    saveRolePermissions(saveRolePermissionInput: $saveRolePermissionInput) {
      rolePermissions {
        id
        permission {
          permissionName
          id
        }
      }
      errors {
        id
        messageKeys
      }
    }
  }
`;

export const GET_USER_ACCOUNTS_COUNT = gql`
  query UserAccountCount($searchInput: SearchInput) {
    userAccountCount(searchInput: $searchInput)
  }
`;
